export const RouteLoadingFallback = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="relative w-12 h-12 mx-auto">
        <div className="absolute inset-0 border-3 border-primary/20 rounded-full" />
        <div className="absolute inset-0 border-3 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    </div>
  );
};
